import { render, staticRenderFns } from "./WalletUsers.vue?vue&type=template&id=4cf450e3"
import script from "./WalletUsers.vue?vue&type=script&lang=js"
export * from "./WalletUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports